import { apiCall } from "../../services/api-service";

export const getApplicationListApi = async (id) => {
  const response = await apiCall(
    "GET",
    `get_applications?type=All&role_id=${id ?? ""}`,
  );
  return response;
};
export const getWidgetListApi = async (applicationId, roleId) => {
  const response = await apiCall(
    "GET",
    `get_signage_permissions?application_id=${applicationId}&type=Internal&role_id=${
      roleId ?? ""
    }`,
  );
  return response;
};

export const getDeviceGroupListApi = async (params) => {
  const response = await apiCall("GET", `device?${params}`);
  return response;
};

export const getGroupListApi = async (params) => {
  const response = await apiCall("GET", `group?${params}`);
  return response;
};

export const getGroupApi = async (id) => {
  const response = await apiCall("GET", `group/${id}`);
  return response;
};

export const createGroupApi = async (data) => {
  const response = await apiCall("POST", "group", data);
  return response;
};

export const updateGroupApi = async (id, body) => {
  const response = await apiCall("PUT", `group/${id}`, body);
  return response;
};

export const getDeleteApi = async (deleteUrl) => {
  const response = await apiCall("DELETE", deleteUrl);
  return response;
};

export const bulkDeleteApi = async (deleteUrl, ids) => {
  const response = await apiCall("DELETE", deleteUrl, { id: ids });
  return response;
};

export const getInternalWidgetsApi = async (id) => {
  const response = await apiCall("GET", `get_internal_widgets/${id}`);
  return response;
};
